export interface ThemeState {
    primaryColor: string;
    font: string;
    darkMode: boolean;
    colorPalette: { [key: string]: { [shade: number]: string } };
    fontStyles: { [key: string]: string };
}


export const COLOR_PALETTE: { [key: string]: { [shade: number]: string } } = {
    default: {
        50: '#f6f6f6',
        100: '#e7e7e7',
        200: '#d1d1d1',
        300: '#b0b0b0',
        400: '#888888',
        500: '#6d6d6d',
        600: '#5d5d5d',
        700: '#4f4f4f',
        800: '#454545',
        900: '#3d3d3d',
        950: '#080808',
    },
    red: {
        50: '#fff0f0',
        100: '#ffdddd',
        200: '#ffc1c1',
        300: '#ff9595',
        400: '#ff5959',
        500: '#ff2626',
        600: '#fc0606',
        700: '#db0000',
        800: '#af0505',
        900: '#900c0c',
        950: '#500000',
    },
    blue: {
        50: '#e8f2ff',
        100: '#d5e6ff',
        200: '#b3cfff',
        300: '#86aeff',
        400: '#577cff',
        500: '#304dff',
        600: '#0d18ff',
        700: '#0b14fe',
        800: '#0711cc',
        900: '#101a9f',
        950: '#0a0e5c',
    },
    green: {
        50: '#edfff3',
        100: '#d5ffe4',
        200: '#aeffcb',
        300: '#6fffa4',
        400: '#0bfe60',
        500: '#00e852',
        600: '#00c23f',
        700: '#009735',
        800: '#05762e',
        900: '#066129',
        950: '#003713',
    },
    yellow: {
        50: '#fdfee8',
        100: '#fdffc2',
        200: '#feff88',
        300: '#fff844',
        400: '#feea0b',
        500: '#eed104',
        600: '#cda301',
        700: '#a47504',
        800: '#875c0c',
        900: '#734b10',
        950: '#432705',
    },
    orange: {
        50: '#fff8ec',
        100: '#fff0d3',
        200: '#ffdca5',
        300: '#ffc26d',
        400: '#ff9d32',
        500: '#ff7f0a',
        600: '#ff6600',
        700: '#cc4902',
        800: '#a1390b',
        900: '#82310c',
        950: '#461604',
    },
    violet: {
        50: '#fbf3ff',
        100: '#f5e3ff',
        200: '#eccdff',
        300: '#dea5ff',
        400: '#ca6cff',
        500: '#b635ff',
        600: '#a50fff',
        700: '#9900ff',
        800: '#7a06c3',
        900: '#65079c',
        950: '#450076',
    },
    cyan: {
        50: '#ebffff',
        100: '#cefdff',
        200: '#a2f9ff',
        300: '#63f1fd',
        400: '#1cdff4',
        500: '#00d2eb',
        600: '#039bb7',
        700: '#0a7b94',
        800: '#126378',
        900: '#145265',
        950: '#063746',
    },




};

export const FONT_STYLE:{[key: string]: string} = {
    'Inter': 'Inter',
    'Roboto': 'Roboto',
    'Poppins': 'Poppins',
    'Open Sans': 'Open Sans',
    'Raleway': 'Raleway',
    'Work Sans': 'Work Sans',
    'DM Sans': 'DM Sans',
    'Quicksand': 'Quicksand',
    'IBM Plex Sans': 'IBM Plex Sans',
    'Dosis': 'Dosis',
}
